export default "__VITE_ASSET__hWk5MMY6__"